import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from './cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { hasError = false, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={hasError || undefined}
      className={cn(
        'w-full bg-bg text-foreground placeholder:text-muted',
        'border rounded-md px-3 py-2 text-sm transition-colors resize-y',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        hasError ? 'border-danger focus-visible:ring-danger' : 'border-border',
        className,
      )}
      {...rest}
    />
  );
});
